import styled from 'styled-components';

export const ErrorText = styled.div`
  color: #ff0000;
  font-size: 0.8rem;
  margin-right: 6px;
`;
